import React, { Component } from 'react'
import * as _ from "underscore";
import ApiModal from './ApiModal';

class ComponentLink extends Component {

  render() {
    return (
      <div className={this.props.className} title={this.props.title}>
        <div className="comboText">
          {_.isNumber(this.props.value) ? this.props.value.toFixed(this.props.pad) : this.props.value}
        </div>
        {this.props.isLinkRequired !="false"? <a className="navLink up-arrow" title="Show result via API call" data-toggle="modal" data-target={"#" + (this.props.url).replace('https:', '').replace(/\//g, '').replace(/\=/g, '').replace(/\./g, '').replace(/\?/g, '').replace(/&/g, '').replace(/,/g, '')}></a>: null}   
        <ApiModal currentUrl={this.props.url} apiResponse={this.props.apiResponse} />
      </div>
    )
  }
}

export default ComponentLink;



// WEBPACK FOOTER //
// ./src/components/ComponentLink.js